import moment from 'moment';

import {
    DISPLAY_DATE_FORMAT_WITH_YEAR,
    DISPLAY_SHORT_DATE_FORMAT,
    TIME_LONG_TIME_FORMAT,
} from '../constants/dateFormats.constants';
import {
    BROADCAST_STATUS,
    TIME_FORMAT,
    BROADCAST_STATUS_MESSAGE,
    SCHEDULE_DATE_FORMAT,
} from '../constants/emailBroadcast.constants';

export const formattedDateTime = (date, time, userLocale) => {
    const year = date.getFullYear();
    const month = (1 + date.getMonth()).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const timePattern = /(\d{2})(\d{2})/; // split time into hours and minutes selectors $1 and $2 respectively
    const timeFormat = time.replace(timePattern, '$1:$2');
    const dateFormat = userLocale === 'en_GB' ? `${day}-${month}-${year}` : `${month}-${day}-${year}`;

    return `${dateFormat} ${timeFormat}`;
};

export const get24HourTime = () => {
    const date = new Date();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}${minutes}`;
};

export const shortDateFormat = (datetime) => {
    const date = moment(Date.parse(datetime)).format(DISPLAY_SHORT_DATE_FORMAT);
    const time = moment(Date.parse(datetime)).format(TIME_LONG_TIME_FORMAT);
    const message = `${date} at ${time}`;

    return message;
};

export const tomorrowsDate = () => {
    const today = new Date();
    const tomorrow = new Date();

    tomorrow.setDate(today.getDate() + 1);

    return tomorrow;
};

export const longDateFormat = (datetime) => {
    const date = moment(Date.parse(datetime)).format(DISPLAY_DATE_FORMAT_WITH_YEAR);
    const time = moment(Date.parse(datetime)).format(TIME_LONG_TIME_FORMAT);
    const message = `${date} at ${time} (${Intl.DateTimeFormat(Date.parse(datetime)).resolvedOptions().timeZone})`;

    return message;
};

function formatBroadcastDateMessage(action, broadcast) {
    const {
        scheduleDateWithoutTimeZone,
        useContactTimeZone,
        scheduledTimeZoneId,
    } = broadcast;

    if (!scheduleDateWithoutTimeZone) {
        return action;
    }

    const scheduleDate = moment(scheduleDateWithoutTimeZone, SCHEDULE_DATE_FORMAT).toDate();

    if (useContactTimeZone) {
        return `${action} for ${shortDateFormat(scheduleDate)} in each contact's timezone`;
    }

    if (scheduledTimeZoneId?.length) {
        return `${action} for ${shortDateFormat(scheduleDate)} in the ${scheduledTimeZoneId} timezone`;
    }

    return `${action} for ${shortDateFormat(scheduleDate)}`;
}

export const broadcastDateMessage = (broadcast, isScheduledEmailDateTimeFixEnabled) => {
    const {
        lastEdit,
        scheduleDate,
        scheduleDateWithoutTimeZone,
        status,
        endDate,
    } = broadcast;

    let message;
    const dateTime = moment(lastEdit);
    const date = dateTime.format('MMM Do');
    const time = dateTime.format(TIME_FORMAT);
    let action = BROADCAST_STATUS_MESSAGE[status];
    const statusFormatted = BROADCAST_STATUS[status];

    switch (statusFormatted) {
    case (BROADCAST_STATUS.QUEUED): {
        const dateToUse = isScheduledEmailDateTimeFixEnabled ? scheduleDateWithoutTimeZone : scheduleDate;

        if (dateToUse) {
            if (isScheduledEmailDateTimeFixEnabled) {
                message = formatBroadcastDateMessage(action, broadcast);
            } else {
                message = `${action} ${shortDateFormat(dateToUse)}`;
            }
        } else {
            message = 'Sending now';
        }
        break;
    }
    case (BROADCAST_STATUS.SCHEDULING):
        if (isScheduledEmailDateTimeFixEnabled) {
            message = formatBroadcastDateMessage(action, broadcast);
        } else {
            message = `${action} for ${shortDateFormat(scheduleDate)}`;
        }
        break;
    case (BROADCAST_STATUS.RESCHEDULING):
        if (isScheduledEmailDateTimeFixEnabled) {
            message = formatBroadcastDateMessage(action, broadcast);
        } else {
            message = `${action} is in progress`;
        }
        break;
    case (BROADCAST_STATUS.PROCESSING):
        message = action;
        break;
    case (BROADCAST_STATUS.CANCELLED):
    case (BROADCAST_STATUS.DONE):
        message = `${action} ${shortDateFormat(endDate)}`;

        break;
    case (BROADCAST_STATUS.ERROR):
        message = 'This broadcast encountered an error';
        break;
    default:
        action = 'Edited';
        message = `Edited on ${date} at ${time}`;
        break;
    }

    return message;
};
